;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function MapIconWithMan() {
  return (
    <svg width="94" height="151" viewBox="0 0 94 151" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_322_889)">
        <path
          d="M46.6899 2.31815C21.7363 2.28948 1.48269 22.2003 1.45361 46.8022C1.45361 46.8213 1.45361 46.8309 1.45361 46.85C1.45361 80.9774 35.3227 88.6302 46.6899 125.825C58.0474 88.6589 91.8681 80.92 91.9262 46.8691C91.8971 22.2576 71.6532 2.31815 46.6899 2.31815Z"
          stroke="#455A63"
          stroke-width="3"
        />
        <path
          d="M26.506 116.551C12.2025 119.436 2.45361 125.131 2.45361 131.704C2.45361 141.182 22.7072 148.854 47.6899 148.854C72.6726 148.854 92.9262 141.172 92.9262 131.704C92.9262 125.131 83.1773 119.436 68.8738 116.551"
          stroke="#FFB400"
          stroke-width="3"
        />
        <path
          d="M64.0944 70.936V64.0761C64.0944 60.1685 54.5297 53.8054 46.6996 53.8054C38.8695 53.8054 29.295 60.1589 29.295 64.0761V70.936"
          stroke="#455A63"
          stroke-width="3"
        />
        <path
          d="M46.69 53.7767C40.4104 53.7767 36.2531 48.5124 36.2531 42.0155V38.0888C36.2531 31.592 40.4201 26.3276 46.69 26.3276C52.9599 26.3276 57.1269 31.592 57.1269 38.0888V42.0155C57.1269 48.5124 52.9599 53.7767 46.69 53.7767Z"
          stroke="#455A63"
          stroke-width="3"
        />
      </g>
      <defs>
        <clipPath id="clip0_322_889">
          <rect width="94" height="150" fill="white" transform="translate(0 0.88501)" />
        </clipPath>
      </defs>
    </svg>
  );
}
